// HolidaysCard.jsx
import React from 'react';
import HolidaysHeader from '../HolidaysHeader/HolidaysHeader';
import HolidaysList from '../HolidaysList/HolidaysList';

const HolidaysCard = ({ holidays }) => {
    return (
        <div className="atlar-card p-3 h-100 d-flex flex-column"> 
            <HolidaysHeader />
            <HolidaysList holidays={holidays} />
        </div>
    );
};

export default HolidaysCard;